/**
 * @param {string | null | undefined} announcementId
 * @param {boolean} shouldSelect
 * @param {string[]} selectedIds
 * @returns {string[]}
 */
export function toggleAnnouncementSelection(announcementId, shouldSelect, selectedIds) {
  if (!announcementId) {
    return selectedIds;
  }
  if (shouldSelect) {
    return selectedIds.includes(announcementId)
      ? selectedIds
      : [...selectedIds, announcementId];
  }
  return selectedIds.filter((id) => id !== announcementId);
}

/**
 * @param {Array<{ _id?: string }>} announcements
 * @param {string[]} selectedIds
 * @returns {string[]}
 */
export function toggleAllAnnouncementSelection(announcements, selectedIds) {
  const allIds = announcements
    .map((item) => (typeof item._id === "string" ? item._id : ""))
    .filter(Boolean);
  if (allIds.length === 0) {
    return [];
  }
  if (selectedIds.length === allIds.length) {
    return [];
  }
  return allIds;
}
